import { useTranslation } from '@cobliteam/i18n';
import { TableCell, TableRow } from '@cobliteam/ui/components/Table';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import type { ColumnDef, Row } from '@tanstack/react-table';

interface DataTablePlaceholderProps<TData, TValue> {
  columnsDef: ColumnDef<TData, TValue>[];
  isLoading: boolean;
  isFetching: boolean;
  rows: Row<TData>[];
  placeholder?: React.ReactNode;
}

const DataTableEmptyState = <TData, TValue>({ columnsDef, isLoading, isFetching, rows, placeholder }: DataTablePlaceholderProps<TData, TValue>) => {
  const { t } = useTranslation('ui-business');

  if (isFetching || isLoading) return null;
  if (!isLoading && rows.length > 0) return null;
  if (rows.length) return null;
  return (
    <TableRow hover={false}>
      <TableCell colSpan={columnsDef.length} className='h-80 w-full'>
        <div className='flex flex-col items-center justify-between gap-2 text-center'>
          {placeholder ? (
            placeholder
          ) : (
            <>
              <div className='aspect-square rounded-full bg-secondary/20 p-5'>
                <Icon name='scan-search' size='2xl' />
              </div>
              <Typography color='secondary'>{t('data_table.no_results_found')}</Typography>
              <Typography color='secondary'>{t('data_table.adjust_filters_or_search')}</Typography>
            </>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default DataTableEmptyState;
